export enum RangeType {
    yesterday = "yesterday",
    today = "today",
    tomorrow = "tomorrow",
    lastWeek = "lastWeek",
    lastSevenDays = "lastSevenDays",
    lastFifteenDays = "lastFifteenDays",
    last15DaysAndToday = "last15DaysAndToday",
    lastThirtyDays = "lastThirtyDays",
    last30DaysAndToday = "last30DaysAndToday",
    lastThreeMonths = "lastThreeMonths",
    lastTwelveMonths = "lastTwelveMonths",
    lastTwoWeeks = "lastTwoWeeks",
    previousDay = "previousDay",
    previousWeek = "previousWeek",
    twoPreviousWeeks = "twoPreviousWeeks",
    currentDay = "currentDay",
    nextDay = "nextDay",
    currentWeek = "currentWeek",
    onGoingWeek = "onGoingWeek",
    weekBefore = "weekBefore",
    onGoingMonth = "onGoingMonth",
    currentMonth = "currentMonth",
    currentYear = "currentYear",
    day = "day",
    lastMonth = "lastMonth",
    custom = "custom",
    selection = "selection",
    nextWeek = "nextWeek",
    nextSevenDays = "nextSevenDays",
    currentAndNextWeek = "currentAndNextWeek",
}
